module.exports = __webpack_public_path__ + "NanumSquareR.1d2032162df7cc5a15dc.eot";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareR.eot
// module id = ../../../../../src/assets/font/NanumSquareR.eot
// module chunks = styles